export const PIGPEN_QUESTIONS = [
    /*
    { question: 'What is the capital of England', answer: 'London' },
    { question: 'What is Britains national broadcaster', answer: 'BBC' },
    { question: 'How many buses come at once', answer: 'Three|3'},
    */
    /*
    { question: 'A triangle has three sides? true or false', answer: 'true|t|y'},
    { question: 'A triangle has five sides? true or false', answer: 'false|f|n'},
    { question: 'A pentagon has five sides? true or false', answer: 'true|t|y'},
    { question: 'A pentagon has seven sides? true or false', answer: 'false|f|n'},
    { question: 'A hexagon has six sides? true or false', answer: 'true|t|y'},
    { question: 'A hexagon has three sides? true or false', answer: 'false|f|n'},
    { question: 'An octagon has eight sides? true or false', answer: 'true|t|y'},
    { question: 'An octagon has seven sides? true or false', answer: 'false|f|n'},
    { question: 'A square is a quadrilateral? true or false', answer: 'true|t|y'},
    { question: 'An isosceles triangle has three equal sides? true or false', answer: 'false|f|n'},
    { question: '25 is a square number? true or false', answer: 'true|t|y'},
    { question: 'A 90 degree angle is known as acute? true or false', answer: 'false|f|n'},
    { question: 'The mean, median and mode are types of averages? true or false', answer: 'true|t|y'},
    { question: 'In a parallelogram, opposite sides are parallel? true or false', answer: 'true|t|y'},
    */
        /* 'do not count your chickens',
        'every dog has his day',
        'let sleeping dogs lie',
        'look before you leap',
        'no news is good news',
        'patience is a virtue',
        'use it or lose it',
        'fortune favours the bold', */

    'Theres no place like home',
    'Love is sharing your popcorn',
    // 'A martini Shaken not stirred',
    'All you need is love',
    'Heres looking at you kid',
    'Patience is the best medicine',
    'Knowledge shrinks as wisdom grows',
    'Stars cant shine without darkness',
    'One fails forward toward success',
    'Never never never give up',
    'Life begins where fear ends',
    'Be present above all else',
    'Keep calm and carry on',
    // 'Peace begins with a smile',
    'While theres life theres hope',
    'Houston we have a problem',
];

export const MAX_LINE_WIDTH = 480;
export const LETTER_SPACING = 3;
export const LINE_HEIGHT = 42;
export const SPACE_WIDTH = 28;

export class PigPenModel {
    cipherPhrase = null;
    alphabet = null;
    potentialAnswers = null;
    phraseDisplayObjects = null;
}